import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { authAPI } from '../_services';

export const PrivateRoute = ({
  component: Component,
  roles,
  authorised = true,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      const currentUser = authAPI.currentUserValue;
      if (!currentUser) {
        // not logged in so redirect to login page with the return url
        return (
          <Redirect
            to={{ pathname: '/login', state: { from: props.location } }}
          />
        );
      }

      // check if route is restricted by role
      if (roles && !currentUser.roles.some(role => roles.includes(role))) {
        // role not authorised so redirect to home page
        return <Redirect to={{ pathname: '/' }} />;
      }

      // check if route is restricted by authorisation
      if (!authorised) {
        // user not authorised so redirect to home page
        return <Redirect to={{ pathname: '/' }} />;
      }

      // authorised so return component
      return <Component {...props} />;
    }}
  />
);
